<p-dialog *ngIf="selectedItem" [(visible)]="selectedItem" [breakpoints]="{ '960px': '75vw', '640px': '100vw' }" [style]="{ width: '50vw', height: '80vh' }">
	<ng-template pTemplate="header">
		<div class="item-name">
			{{ selectedItem.displayName || selectedItem.ooMenuItem.name }}
		</div>
	</ng-template>

	<div class="subscription-item-modal">
		<div class="image">
			<img
				[src]="
					'https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/' + venueService.ooVenue.venueKey + '/' + selectedItem.ooMenuItem.imageKey
				"
				width="100%"
				height="auto"
			/>
		</div>
		<div class="description display-12">
			{{ selectedItem.description }}
		</div>
	</div>

	<ng-template pTemplate="footer">
		<div class="frequency-selector">
			<div class="mx-2 p-fluid">
				<p-selectButton
					name="forSelect"
					[options]="selectedItemFrequencies"
					[(ngModel)]="selectedFrequency"
					optionValue="value"
					syleClass="w-100"
					[style]="{ width: '100%' }"
				>
					<ng-template let-item>
						<div class="frequency-item">
							<div class="display-16">
								{{ item.label }}
							</div>
							<div class="display-16">
								{{ venueService.menuItemGetPriceFromNumber(selectedItem.ooMenuItem, selectedItem.priceNumber) | currency }}
							</div>
						</div>
					</ng-template>
				</p-selectButton>
			</div>
		</div>
		<div class="d-flex">
			<div class="mx-auto">
				<p-button pRipple styleClass="p-button-raised p-button-success m-2" (click)="onAddToOrder()" [disabled]="!selectedFrequency">
					<ng-template pTemplate="content">
						<div class="d-flex justify-content-center">
							<fa-icon [icon]="['far', 'shopping-cart']" size="lg" class="ms-1 me-2"></fa-icon>
							Add to my Subscriptions
						</div>
					</ng-template>
				</p-button>
			</div>
		</div>
	</ng-template>
</p-dialog>

<ng-template #subscriptionItemTemplate> </ng-template>
